/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Directive, TemplateRef} from '@angular/core';
export class WizardPageTitleDirective {
/**
 * @param {?} pageTitleTemplateRef
 */
constructor(public pageTitleTemplateRef: TemplateRef<any>) {}
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "[clrPageTitle]"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
];
}

function WizardPageTitleDirective_tsickle_Closure_declarations() {
/** @type {?} */
WizardPageTitleDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
WizardPageTitleDirective.ctorParameters;
/** @type {?} */
WizardPageTitleDirective.prototype.pageTitleTemplateRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
